import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { AuthErrorScreen, AuthLoadingScreen } from './AuthErrorScreen'
import { persistAuthRedirectPath } from './storage'

export function ProtectedRoute() {
  const { authState, loading } = useAuth()
  const location = useLocation()

  if (loading) return <AuthLoadingScreen />

  const targetPath = `${location.pathname}${location.search}${location.hash}`

  if (authState === 'ready') {
    return <Outlet />
  }

  if (authState === 'error') {
    return <AuthErrorScreen />
  }

  persistAuthRedirectPath(targetPath)

  if (authState === 'verifyEmail') {
    return <Navigate to="/verifieer-email" replace />
  }

  if (authState === 'needsProfile') {
    return <Navigate to="/account-aanmaken" replace />
  }

  return <Navigate to="/login" state={{ from: location }} replace />
}
